import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { OutgoingContent3t2ohmyam9o76 as OutgoingContent } from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { PipelinePhase2q3d54imxjlma as PipelinePhase } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelinePhase.mjs';
import { Phases_getInstance27czzec4fvnke as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isSuspendFunction153vlp5l2npj9 as isSuspendFunction } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Phases_getInstance2txhvlby2jeqr as Phases_getInstance_0 } from '../statement/HttpResponsePipeline.mjs';
import { contentLength2suzxu1lzutku as contentLength } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import { observable2pw4p3n7s3klf as observable } from '../utils/ByteChannelUtils.mjs';
import { replaceResponse3ut5eo3odxj99 as replaceResponse } from '../call/DelegatedCall.mjs';
import {
  ObservableContent3ft2pt0w2oysd as ObservableContent,
  ProgressListener886sg277haqw as ProgressListener,
} from '../content/ObservableContent.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { createClientPlugin16sdkdabbewya as createClientPlugin } from './api/CreatePluginUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_UploadProgressListenerAttributeKey() {
  _init_properties_BodyProgress_kt__s0v569();
  return UploadProgressListenerAttributeKey;
}
var UploadProgressListenerAttributeKey;
function get_DownloadProgressListenerAttributeKey() {
  _init_properties_BodyProgress_kt__s0v569();
  return DownloadProgressListenerAttributeKey;
}
var DownloadProgressListenerAttributeKey;
function get_BodyProgress() {
  _init_properties_BodyProgress_kt__s0v569();
  return BodyProgress;
}
var BodyProgress;
function AfterRenderHook$install$slambda($handler) {
  return constructCallableReference(function *($this$intercept, content, $completion) {
    var tmp;
    if (!(content instanceof OutgoingContent())) {
      return Unit_instance;
    }
    var tmp0_elvis_lhs = yield* $handler($this$intercept.y4s_1, content, $completion);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var newContent = tmp_0;
    yield* $this$intercept.a4s(newContent, $completion);
    return Unit_instance;
  }, 2);
}
var AfterRenderHookClass;
function AfterRenderHook() {
  if (AfterRenderHookClass === VOID) {
    class $ {
      h5m(client, handler) {
        var observableContentPhase = new (PipelinePhase())('ObservableContent');
        client.g5g_1.z4s(Phases_getInstance().l5m_1, observableContentPhase);
        client.g5g_1.c4t(observableContentPhase, AfterRenderHook$install$slambda(handler));
      }
      n5m(client, handler) {
        return this.h5m(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'AfterRenderHook');
    AfterRenderHookClass = $;
  }
  return AfterRenderHookClass;
}
var AfterRenderHook_instance;
function AfterRenderHook_getInstance() {
  return AfterRenderHook_instance;
}
function AfterReceiveHook$install$slambda($handler) {
  return constructCallableReference(function *($this$intercept, response, $completion) {
    var newResponse = yield* $handler(response, $completion);
    var tmp;
    if (!(newResponse == null)) {
      yield* $this$intercept.a4s(newResponse, $completion);
      tmp = Unit_instance;
    }
    return Unit_instance;
  }, 2);
}
var AfterReceiveHookClass;
function AfterReceiveHook() {
  if (AfterReceiveHookClass === VOID) {
    class $ {
      o5m(client, handler) {
        var tmp = Phases_getInstance_0().r5m_1;
        client.j5g_1.c4t(tmp, AfterReceiveHook$install$slambda(handler));
      }
      n5m(client, handler) {
        return this.o5m(client, (!(handler == null) ? isSuspendFunction(handler, 1) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'AfterReceiveHook');
    AfterReceiveHookClass = $;
  }
  return AfterReceiveHookClass;
}
var AfterReceiveHook_instance;
function AfterReceiveHook_getInstance() {
  return AfterReceiveHook_instance;
}
function withObservableDownload(_this__u8e3s4, listener) {
  _init_properties_BodyProgress_kt__s0v569();
  var tmp = _this__u8e3s4.y5i();
  return replaceResponse(tmp, VOID, ($this$replaceResponse) => observable($this$replaceResponse.g5j(), $this$replaceResponse.cw(), contentLength($this$replaceResponse), listener)).t5g();
}
function BodyProgress$lambda($this$createClientPlugin) {
  _init_properties_BodyProgress_kt__s0v569();
  var tmp = AfterRenderHook_instance;
  $this$createClientPlugin.x5m(tmp, BodyProgress$lambda$slambda());
  var tmp_0 = AfterReceiveHook_instance;
  $this$createClientPlugin.x5m(tmp_0, BodyProgress$lambda$slambda_0());
  return Unit_instance;
}
function BodyProgress$lambda$slambda() {
  return constructCallableReference(function *(request, content, $completion) {
    var tmp0_elvis_lhs = request.f5i_1.l4n(get_UploadProgressListenerAttributeKey());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var listener = tmp;
    return new (ObservableContent())(content, request.e5i_1, listener);
  }, 2);
}
function BodyProgress$lambda$slambda_0() {
  return constructCallableReference(function *(response, $completion) {
    var tmp0_elvis_lhs = response.y5i().r5i().s5i().l4n(get_DownloadProgressListenerAttributeKey());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var listener = tmp;
    return withObservableDownload(response, listener);
  }, 1);
}
var properties_initialized_BodyProgress_kt_pmfrhr;
function _init_properties_BodyProgress_kt__s0v569() {
  if (!properties_initialized_BodyProgress_kt_pmfrhr) {
    properties_initialized_BodyProgress_kt_pmfrhr = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'UploadProgressListenerAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(ProgressListener());
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(ProgressListener()), arrayOf([]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$2 = tmp_0;
    var tmp$ret$1 = new (TypeInfo())(tmp, tmp$ret$2);
    UploadProgressListenerAttributeKey = new (AttributeKey())(name, tmp$ret$1);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name_0 = 'DownloadProgressListenerAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_2 = getKClass(ProgressListener());
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_3;
    try {
      tmp_3 = createKType(getKClass(ProgressListener()), arrayOf([]), false);
    } catch ($p_0) {
      var tmp_4;
      if ($p_0 instanceof Error) {
        var _unused_var__etf5q3_0 = $p_0;
        tmp_4 = null;
      } else {
        throw $p_0;
      }
      tmp_3 = tmp_4;
    }
    var tmp$ret$2_0 = tmp_3;
    var tmp$ret$1_0 = new (TypeInfo())(tmp_2, tmp$ret$2_0);
    DownloadProgressListenerAttributeKey = new (AttributeKey())(name_0, tmp$ret$1_0);
    BodyProgress = createClientPlugin('BodyProgress', BodyProgress$lambda);
  }
}
//region block: init
AfterRenderHook_instance = new (AfterRenderHook())();
AfterReceiveHook_instance = new (AfterReceiveHook())();
//endregion
//region block: exports
export {
  get_BodyProgress as get_BodyProgresstom4nhodv8bj,
};
//endregion

//# sourceMappingURL=BodyProgress.mjs.map
